export const API_ERR_NETWORK_NO_RESPONSE = 'api_err_network_no_response';
export const API_ERR_NETWORK_SETTING_UP = 'api_err_network_setting_up';
export const API_ERR_ZOD_VALIDATION = 'api_err_zod_validation';
export const API_ERR_UNKNOWN = 'api_err_unknown';
